export { SwatchFilter } from './SwatchFilter';
